"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameInput = void 0;
var react_1 = __importDefault(require("react"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var StartAdornment_1 = require("./StartAdornment");
var styles_1 = require("./styles");
var useFrameInputStyles = (0, system_1.makeStyles)(function (theme) { return (__assign(__assign({ root: __assign(__assign(__assign(__assign({}, (0, styles_1.rootDefaultStyles)(theme.go)), { borderRadius: 16, border: "2px solid ".concat(theme.go.schemes.colors.system.Line), '&$focused': {
            borderColor: theme.go.schemes.colors.system.ControlMain,
        }, '&$error': {
            borderColor: theme.go.schemes.colors.system.BgAttention,
        } }), theme.go.mixins.effects.Hovered()), theme.go.mixins.effects.Pressed()), focused: {}, input: function (props) { return (__assign(__assign({}, styles_1.inputDefaultStyles), { padding: (0, styles_1.getPaddings)(props) })); } }, styles_1.defaultAdornmentStyle), { disabled: (0, styles_1.disableDefaultStyles)(theme.go), error: {}, notchedOutline: {
        border: 'none !important',
    }, label: (0, styles_1.commonLabelStyles)(theme.go, system_1.InputVariants.Frame) })); });
exports.FrameInput = react_1.default.forwardRef(function FrameInput(_a, ref) {
    var _b, _c, _d, _e, _f;
    var iconStart = _a.iconStart, clearable = _a.clearable, props = __rest(_a, ["iconStart", "clearable"]);
    var _g = useFrameInputStyles({
        iconStart: iconStart,
        disabled: props.disabled,
        clearable: clearable,
        variant: system_1.InputVariants.Frame,
    }), label = _g.label, frameInputClasses = __rest(_g, ["label"]);
    var startAdornment = ((props === null || props === void 0 ? void 0 : props.InputProps) || {}).startAdornment;
    startAdornment =
        startAdornment || (iconStart ? react_1.default.createElement(StartAdornment_1.StartAdornment, null, iconStart) : null);
    return (react_1.default.createElement(TextField_1.default, __assign({}, props, { ref: ref, variant: "outlined", InputLabelProps: __assign(__assign({}, props.InputLabelProps), { className: (0, utils_1.cn)(label, (_b = props.InputLabelProps) === null || _b === void 0 ? void 0 : _b.className) }), InputProps: __assign(__assign({}, props.InputProps), { startAdornment: startAdornment, classes: __assign(__assign({}, frameInputClasses), { root: (0, utils_1.cn)(frameInputClasses.root, (_d = (_c = props.InputProps) === null || _c === void 0 ? void 0 : _c.classes) === null || _d === void 0 ? void 0 : _d.root), input: (0, utils_1.cn)(frameInputClasses.input, (_f = (_e = props.InputProps) === null || _e === void 0 ? void 0 : _e.classes) === null || _f === void 0 ? void 0 : _f.input) }) }) })));
});
